import { useEffect } from 'react';
import { HotelRecord, Timeframe } from '../../../../common/types';
import { useKeenQuery } from '../../../../utils/keen';

const useTotalRevenueByCategoryData = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const [
    {
      data: totalRevenueByCategory = [],
      loading: isTotalRevenueByCategoryLoading,
    },
    queryTotalRevenueByCategory,
  ] = useKeenQuery<{ categoryId: string; result: number }[]>();

  useEffect(() => {
    queryTotalRevenueByCategory({
      analysisType: 'sum',
      eventCollection: 'orders',
      targetProperty: 'total',
      groupBy: 'category_id',
      filters: [
        {
          propertyName: 'hotel_id',
          operator: 'eq',
          propertyValue: hotel.id,
        },
        {
          propertyName: 'test_order',
          operator: 'eq',
          propertyValue: false,
        },
      ],
      timeframe,
    });
  }, [hotel.id, queryTotalRevenueByCategory, timeframe]);

  return {
    data: totalRevenueByCategory,
    loading: isTotalRevenueByCategoryLoading,
  };
};

export default useTotalRevenueByCategoryData;
